import { Observable } from 'rxjs';
import { Type, EventEmitter } from '@angular/core';

import { AbstractControl, ValueControlViewModel } from './control.types';
/**
 * @description æ§ä»¶éªè¯å¨éè¯¯
 *
 * @export
 */
export class ControlValidatorError {
  /**
   * @description æ¯å¦éªè¯æåï¼æåtrueï¼å¤±è´¥false
   *
   * @memberof ControlValidatorError
   */
  success: boolean;
  /**
   * @description éªè¯å¤±è´¥ä¿¡æ¯
   *
   * @memberof ControlValidatorError
   */
  message: string;
  constructor(success?: boolean, message?: string) {
    this.success = success;
    this.message = message;
  }
}

/**
 * @description æ§ä»¶éªè¯å¨åºç±»
 *
 * @export
 * @abstract
 */
export abstract class ControlValidatorBase {
  /**
   * @description å³èæ§ä»¶
   *
   * @memberof ControlValidatorBase
   */
  control: AbstractControl<ValueControlViewModel>;
  /**
   * @description éè¯¯ä¿¡æ¯
   *
   * @memberof ControlValidatorBase
   */
  error: ControlValidatorError;
  /**
   * @description éªè¯å¨model
   *
   * @memberof ControlValidatorBase
   */
  model: any;

  /**
   * éªè¯ä¸­
   *
   * @memberof ControlValidatorBase
   */
  validating: boolean;
  /**
   * @description æ§ä»¶ç±»å
   *
   * @abstract
   * @memberof ControlValidatorBase
   */
  abstract type: string;
  /**
   * @description éªè¯æ¶æº
   *
   * @abstract
   * @memberof ControlValidatorBase
   */
  abstract validateMoment: ControlValidateMoment;

  constructor() {
    this.error = new ControlValidatorError(true, ``);
  }
}

/**
 * @description åæ­¥éªè¯å¨
 *
 * @export
 * @abstract
 */
export abstract class ControlValidator extends ControlValidatorBase {
  /**
   * @description åæ­¥æ ¡éª
   *
   * @abstract
   * @returns è¿åéªè¯ç»æä¿¡æ¯
   * @memberof ControlValidator
   */
  abstract validate(): ControlValidatorError;
}

/**
 * @description å¼æ­¥éªè¯å¨
 *
 * @export
 * @abstract
 */
export abstract class ControlValidatorAsync extends ControlValidatorBase {
  /**
   * @description  å¼æ­¥æ ¡éª
   *
   * @abstract
   * @returns  ä¸ä¸ªå¯ç»ç»çControlValidatorErrorçå¯è§å¯å¯¹è±¡
   * @memberof ControlValidatorAsync
   */
  abstract validateAsync(): Observable<ControlValidatorError>;

  constructor() {
    super();
  }
}

/**
 * @description æ§ä»¶éªè¯å¨ç±»å
 *
 * @export
 * @enum {number}
 */
export enum ControlValidatorType {
  // å¿å¡«
  Required = 'required',
  // å¯ä¸
  Unique = 'unique',
  // å­ç¬¦é¿åº¦
  StringLength = 'stringLength',
  // æ­£åè¡¨è¾¾å¼
  RegularExpression = 'regularExpression',
  // æ­£åè¡¨è¾¾å¼ åé¨ï¼æ²¡æç¼è¾å¨
  RegularExpressionInternal = 'regularExpressionInternal',
  // æ°å¼èå´
  DigitalRange = 'digitalRange',
  // æ°å¼ç±»å
  DigitalType = 'digitalType',
  // éå¶ä¸ä¼ æä»¶ç±»å
  FileTypeOfUpload = 'fileTypeOfUpload',
  // ä¸ä¼ æä»¶å¤§å°
  FileSizeOfUpload = 'fileSizeOfUpload',
  // åè®¸å¤ä¸ªæä»¶ä¸ä¼ 
  AllowMultiOfUpload = 'AllowMultiOfUpload',

  // èåæ ¡éª
  UnionCheck = 'unionCheck'
}

// éªè¯æ¶å»
/**
 * @description æ§ä»¶éªè¯æ¶å»
 *
 * @export
 * @enum {number}
 */
export enum ControlValidateMoment {
  // å¤±å»ç¦ç¹
  Blur,
  // è¾å¥
  Input,
  // å¼æ¹å
  Change
}

/**
 * @description æ½è±¡éªè¯å¨ç¼è¾å¨
 *
 * @export
 */
export interface AbstractValidatorEditor<T> {
  /**
   * @description å³èæ§ä»¶
   *
   * @memberof AbstractValidatorEditor
   */
  control: AbstractControl<any>;
  /**
   * @description æ é¢
   *
   * @memberof AbstractValidatorEditor
   */
  caption: string;
  /**
   * @description åç§°
   *
   * @memberof AbstractValidatorEditor
   */
  validatorName: string;
  /**
   * @description è®¾ç½®
   *
   * @memberof AbstractValidatorEditor
   */
  settings: any;
  /**
   * @description éªè¯å¨Model
   *
   * @memberof AbstractValidatorEditor
   */
  model: ControlValidatorModel<T>;
  /**
   * åå§åå®æ
   *
   */
  initComplete: boolean;
  /**
   * å¼æ¹åäºä»¶
   *
   * @memberof AbstractValidatorEditor
   */
  modelChange: EventEmitter<ControlValidatorModel<T>>;
}

/**
 * @description æ§ä»¶éªè¯å¨model
 *
 * @export
 */
export class ControlValidatorModel<T> {
  /**
   * @description æ¯å¦éä¸­
   *
   * @memberof ControlValidatorModel
   */
  required: boolean;
  /**
   * @description æ°æ®
   *
   * @memberof ControlValidatorModel
   */
  data: T;
  constructor() {
    this.required = undefined;
    this.data = undefined;
  }
}

export interface DigitTypeValidatorValue {
  isInteger: boolean;
  isFloat: boolean;
  float: { decimalPlaces: number };
}

export interface FileUploadFileTypeValidatorValue {
  hasDocument: boolean;
  hasImage: boolean;
  hasCompressedPackage: boolean;
}

export interface FileUploadFileSizeValidatorValue {
  size: number;
}
// æ­£åéªè¯å¨model
export interface RegexValidatorModel {
  name: string;
  text: string;
  expression?: string;
  errorMessage?: string;
  validate?(value: any): ControlValidatorError;
}

// èåæ ¡éªéªè¯å¨
export interface UnionCheckValidatorModel {
  unionId: string;
  unionRelation: string;
  errorMessage?: string;
  validate?(value: any): ControlValidatorError;
}

// èåæ ¡éªå³èå³ç³»
export interface UnionCheckRelation {
  name: string;
  operator: string;
}

/**
 * @description éªè¯å¨ç»å®model
 *
 * @export
 */
export interface ValidatorBindModel {
  /**
   * @description éªè¯å¨åç§°
   *
   * @memberof ValidatorBindModel
   */
  key: string;
  /**
   * @description éªè¯å¨ç±»å
   *
   * @memberof ValidatorBindModel
   */
  value: Type<ControlValidatorBase>;
  /**
   * @description éªè¯å¨çæå·¥åï¼ç¨æ¥çæéªè¯å¨ï¼è¿åå¼å¿é¡»æ¯ControlValidatorBaseçä¸ä¸ªå®ä¾
   *
   * @memberof ValidatorBindModel
   */
  factory?: Function;
  /**
   * @description éªè¯å¨æé å½æ°çä¾èµé¡¹ãå¦æéªè¯å¨æé å½æ°æä¾èµé¡¹ï¼éªè¯å¨å·¥åfactoryä¹ä¸è½ä¸ºç©º
   *
   * @memberof ValidatorBindModel
   */
  deps?: any[];
}
